import React, { useEffect } from 'react';

import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { useActivityTracker } from './hooks/useActivityTracker';
import { SessionStopJustPauseProps } from './SessionStop.types';
import { useSessionStopped } from './hooks/useSessionStopped/useSessionStopped';
import { usePauseOnSessionStopped } from './hooks/usePauseOnSessionStopped';

export const SessionStopJustPause: React.FC<SessionStopJustPauseProps> = ({
    pause,
    playingState,
}) => {
    const { sessionStopped, reset } = useSessionStopped();

    usePauseOnSessionStopped(pause, sessionStopped);

    useActivityTracker({ sessionStopped, reset });

    useEffect(() => {
        if (sessionStopped && playingState === PlayingState.play) {
            reset();
        }
    }, [playingState, reset, sessionStopped]);

    return null;
};
